
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol id=\"information_icon_jax_5f0a550d0b37ceb3959f2791f8fac41d\" ><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5 1.093C5.613 1.093.846 5.894.846 11.81S5.613 22.527 11.5 22.527s10.654-4.801 10.654-10.717S17.387 1.093 11.5 1.093zM1.846 11.81c0-5.37 4.325-9.717 9.654-9.717s9.654 4.348 9.654 9.717c0 5.37-4.325 9.717-9.654 9.717s-9.654-4.348-9.654-9.717zM11 7.088a.8.8 0 0 0 .798-.804.8.8 0 0 0-.798-.803.8.8 0 0 0-.798.803.8.8 0 0 0 .798.804zm0 10.69c.276 0 .5-.225.5-.503V9.361a.502.502 0 0 0-.5-.503c-.276 0-.5.226-.5.503v7.914c0 .278.224.503.5.503z\" fill=\"#2A2A2A\"/></symbol>";
module.exports = sprite.add(image, "information_icon_jax_5f0a550d0b37ceb3959f2791f8fac41d");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/information_icon.svg
// module id = 1461
// module chunks = 1